<template>
  <div class="c-filter">
    <div class="c-form">
      <ElForm label-width="50" inline class="elementui-common-form-styles" v-highlight>
        <ElFormItem>
          <ThrottleSelector v-model="mgameId" :list="gameData" style="width: 160px" placeholder="请选择中间件游戏" filterable clearable />
        </ElFormItem>

        <ElFormItem>
          <ThrottleSelector v-model="platform" :list="platformData" style="width: 160px" placeholder="请选择平台" filterable clearable />
        </ElFormItem>

        <div label-width="0" class="bg-transparent g-pull-right">
          <div class="operate-btns">
            <Button type="primary" ghost @click="$emit('on-down')">模版下载</Button>
            <Upload action="" :before-upload="preUpload" accept="application/vnd.ms-excel,.xls,.xlsx,.csv">
              <Button type="primary" ghost>导入回款标准</Button>
            </Upload>
            <Button type="primary" @click="$emit('on-add')">新建回款标准</Button>
          </div>
        </div>
      </ElForm>
    </div>
  </div>
</template>
<script>
import ThrottleSelector from '@/components/throttle-select/index.vue'
import { platformData } from '../../data/platformData.js'
export default {
  name: 'GameFilter',
  components: { ThrottleSelector },
  props: {
    gameData: {
      type: Array
    }
  },
  data() {
    return {
      mgameId: '',
      platform: '',
      platformData
    }
  },
  methods: {
    sendEvent() {
      this.$emit('on-change', {
        platform: this.platform === '' ? undefined : this.platform,
        mgameId: this.mgameId === '' ? undefined : this.mgameId
      })
    },
    preUpload(file) {
      this.emitImport(file)
      return false
    },
    emitImport(file) {
      this.$emit('on-import', file)
    }
  },
  watch: {
    platform() {
      this.sendEvent()
    },
    mgameId() {
      this.sendEvent()
    }
  }
}
</script>
<style lang="scss" scoped>
.operate-btns {
  display: flex;
}
</style>
